export default __webpack_public_path__ + "static/media/11-60.0e185786.jpeg";